/**
 * 行情页面 - WebSocket实时更新版
 * 使用WebSocket接收实时行情推送，替代HTTP轮询
 */

import PageNav from "@/components/PageNav/PageNav.vue";
import Footer from "@/components/Footer/footer.vue";
import kline from "@/components/kline/kline.vue";
import {Swiper, SwiperSlide} from 'swiper/vue';
import {Navigation, Pagination} from 'swiper/modules';

import currencyApi from '@/common/api/currency';
import futuresApi from '@/common/api/futures';
import wsManager from '@/common/websocket/WebSocketManager';
import logger from '@/common/util/logger';
import util from '@/common/util';

import {mapGetters} from "vuex";

let trades = false;
let tab = 1;

export default {
    components: {
        Footer,
        PageNav,
        Swiper,
        SwiperSlide,
        kline
    },
    computed: {
        ...mapGetters(['userTheme', 'isLogin', 'userId']),
        
        paginationText() {
            const currentLang = this.$i18n?.locale || 'en-US';
            if (currentLang === 'en-US') {
                return `Total ${this.total} items`;
            }
            return `共 ${this.total} 条`;
        }
    },
    data() {
        return {
            loop: true,
            subModules: [Navigation],
            selectVal: 'USDT',
            coinIndex: 0,
            coinList: [
                {
                    title: 'USDT',
                    currency: []
                }
            ],
            tagSelected: 0,
            activeIndex: 0,
            pricesort: 1,
            subtabOptions: [
                'quotes.u_margin_futures',
                'quotes.coin_margin_futures',
                'quotes.usdc_futures'
            ],
            subActive: 0,
            tradeCurrency: [{currency: []}],
            total: 0,
            psize: 30,
            list: [],
            page: 1,
            futures:[],
            optionCoinList: [],
            optionTagSelected: 0,
            allFuturesData: [],
            // WebSocket连接状态
            wsConnected: false
        }
    },
    async mounted() {
        logger.log('📊 行情页面加载 - WebSocket实时更新版');
        
        // 获取初始数据
        await this.getTradesCurrency();
        
        // 连接WebSocket获取实时行情
        this.connectWebSocket();
    },
    beforeUnmount() {
        logger.log('🧹 行情页面组件销毁，清理WebSocket资源...');
        
        // 断开WebSocket连接
        wsManager.disconnect('quotes-trade');
        this.wsConnected = false;
    },
    methods: {
        /**
         * 搜索功能
         */
        search(e){
            if(e !== ''){
                this.list = this.tradeCurrency[this.tagSelected]['currency'].filter((item)=>{
                    return item.symbol.toLowerCase().includes(e.toLowerCase());
                });
            }else{
                if(tab === 1){
                    this.page = 1;
                    this.list = trades[this.tagSelected]['currency'].slice(this.psize * (this.page - 1), this.page * this.psize);
                }else{
                    this.page = 1;
                    this.list = this.tradeCurrency[this.tagSelected]['currency'].slice(this.psize * (this.page - 1), this.page * this.psize);
                }
            }
        },
        
        /**
         * 现货分页
         */
        nextPage(e) {
            this.page = e;
            this.list = this.tradeCurrency[this.tagSelected]['currency'].slice(this.psize * (this.page - 1), this.page * this.psize);
        },
        
        /**
         * 期权分页
         */
        nextPageOption(e) {
            this.page = e;
        },
        
        /**
         * 跳转到现货交易
         */
        toTrade(item) {
            this.$util.setCache('trade-current', JSON.stringify(item));
            return this.$router.push('/spot');
        },
        
        /**
         * 切换标签(现货/合约/期权)
         */
        switchTab(e) {
            tab = parseInt(e);
            this.list = [];
            if(parseInt(e) !== 1 && !trades){
                trades = this.tradeCurrency;
            }
            if(parseInt(e) === 1){
                this.page = 1;
                this.list = trades[this.tagSelected]['currency'].slice(this.psize * (this.page - 1), this.page * this.psize);
            }
            if(parseInt(e) === 2)
            {
                this.tagSelected = 0;
                currencyApi.contractCurrencyList().then(res => {
                    this.tradeCurrency = res.data;
                    this.list = this.tradeCurrency[this.tagSelected]['currency'].slice(this.psize * (this.page - 1), this.page * this.psize);
                    this.page = 1;
                    this.total = res.data[this.tagSelected]['currency'].length;
                }).catch(error => {
                    logger.error('❌ 合约行情获取失败:', error);
                    if (error.message && error.message.includes('401')) {
                        logger.log('🔐 用户未登录，需要登录后才能查看合约行情');
                        throw error;
                    }
                });
            }
            if(parseInt(e) === 3){
                this.optionTagSelected = 0;
                Promise.all([
                    futuresApi.getCurrency(),
                    currencyApi.tradeCurrencyList()
                ]).then(([futuresRes, tradesRes]) => {
                    const spotData = tradesRes.data?.[0]?.currency || [];
                    const spotDataMap = {};
                    spotData.forEach(spot => {
                        if (spot.symbol) {
                            spotDataMap[spot.symbol] = spot;
                        }
                    });
                    const futuresData = futuresRes.data?.map(futures => {
                        const matchedSpot = spotDataMap[futures.symbol];
                        return {
                            ...futures,
                            quota: matchedSpot?.quota || 0,
                            quantity: matchedSpot?.quantity || 0,
                            _dataSource: matchedSpot ? 'spot' : 'futures'
                        };
                    }) || [];
                    this.allFuturesData = futuresData;
                    this.generateOptionCoinList(futuresData);
                    this.filterFuturesByCategory();
                }).catch(error => {
                    logger.error('❌ 获取期权或现货数据失败:', error);
                    if (error.message && error.message.includes('401')) {
                        logger.log('🔐 用户未登录，需要登录后才能查看期权行情');
                        throw error;
                    }
                    futuresApi.getCurrency().then(res => {
                        const futuresData = res.data || [];
                        this.allFuturesData = futuresData;
                        this.generateOptionCoinList(futuresData);
                        this.filterFuturesByCategory();
                    }).catch(futuresError => {
                        logger.error('❌ 期权数据降级获取也失败:', futuresError);
                        if (futuresError.message && futuresError.message.includes('401')) {
                            logger.log('🔐 用户未登录，需要登录后才能查看期权行情');
                            throw futuresError;
                        }
                    });
                });
            }
        },
        
        /**
         * 处理选择
         */
        handleSelect(e) {
            logger.log('handleSelect:', e);
            this.selectVal = e;
        },
        
        /**
         * 币种变化
         */
        coinChange(item, index) {
            logger.log('coinChange:', item.subTabs);
            this.coinIndex = index;
        },
        
        /**
         * 跳转到期权交易页面
         */
        goToOptionTrade(currency) {
            if (!currency || !currency.symbol) {
                logger.warn('⚠️ 币种信息不完整，无法跳转');
                return;
            }
            logger.log('🎯 跳转到期权交易:', currency.symbol);
            this.$router.push({
                path: '/flashOption',
                query: {
                    symbol: currency.symbol,
                    currency_id: currency.currency_id || currency.id,
                    currency_name: currency.currency_name || currency.symbol
                }
            });
        },
        
        /**
         * 生成期权分类列表
         */
        generateOptionCoinList(futuresData) {
            const allText = this.$t('quotes.all');
            if (!futuresData || futuresData.length === 0) {
                this.optionCoinList = [{ title: allText, symbol: 'ALL' }];
                return;
            }
            const symbolSet = new Set();
            futuresData.forEach(item => {
                if (item.symbol) {
                    symbolSet.add(item.symbol);
                }
            });
            const coinList = [{ title: allText, symbol: 'ALL' }];
            const sortedSymbols = Array.from(symbolSet).sort();
            sortedSymbols.forEach(symbol => {
                coinList.push({
                    title: symbol,
                    symbol: symbol
                });
            });
            this.optionCoinList = coinList;
            logger.log('📋 期权分类列表已生成:', this.optionCoinList);
        },
        
        /**
         * 处理期权分类标签点击
         */
        handleOptionTagClick(index) {
            this.optionTagSelected = index;
            this.page = 1;
            this.filterFuturesByCategory();
        },
        
        /**
         * 根据选中的分类筛选期权数据
         */
        filterFuturesByCategory() {
            if (!this.allFuturesData || this.allFuturesData.length === 0) {
                this.futures = [];
                this.total = 0;
                return;
            }
            const selectedCategory = this.optionCoinList[this.optionTagSelected];
            if (!selectedCategory) {
                this.futures = this.allFuturesData;
                this.total = this.allFuturesData.length;
                return;
            }
            if (selectedCategory.symbol === 'ALL') {
                this.futures = this.allFuturesData;
            } else {
                this.futures = this.allFuturesData.filter(item => {
                    return item.symbol === selectedCategory.symbol;
                });
            }
            this.total = this.futures.length;
            this.page = 1;
            logger.log(`🎯 期权分类筛选: ${selectedCategory.title}, 共 ${this.total} 条数据`);
        },
        
        /**
         * 连接WebSocket获取实时行情
         */
        connectWebSocket() {
            logger.log('🔌 行情页面连接WebSocket...');
            
            wsManager.connect('trade', {
                onMessage: this.handleWebSocketMessage,
                onOpen: () => {
                    logger.log('✅ 行情页面WebSocket连接成功');
                    this.wsConnected = true;
                },
                onError: (error) => {
                    logger.error('❌ 行情页面WebSocket连接错误:', error);
                    this.wsConnected = false;
                },
                onClose: () => {
                    logger.log('🔌 行情页面WebSocket连接关闭');
                    this.wsConnected = false;
                },
                userId: this.isLogin ? this.userId : null,
                enableHeartbeat: true,
                enableUserIdUpdate: this.isLogin
            });
        },
        
        /**
         * 处理WebSocket消息
         */
        handleWebSocketMessage(data) {
            if (!data || !data.type) return;
            
            // type 100: ticker数据(价格更新)
            if (data.type === 100 && data.data && data.data.data) {
                this.updateCurrencyPrices(data.data.data);
            }
        },
        
        /**
         * 更新币种价格
         */
        updateCurrencyPrices(tickerData) {
            let updateCount = 0;
            
            // 1. 更新现货数据
            if (this.tradeCurrency && this.tradeCurrency[0] && this.tradeCurrency[0].currency) {
                const currencies = this.tradeCurrency[0].currency;
                
                currencies.forEach((currency, index) => {
                    const ticker = util.getCurrentTicker(currency.id, tickerData);
                    if (ticker && ticker.c) {
                        // 更新价格数据
                        this.tradeCurrency[0].currency[index] = {
                            ...currency,
                            new_price: parseFloat(ticker.c),
                            change_rate: parseFloat(ticker.P),
                            high_price: parseFloat(ticker.h),
                            low_price: parseFloat(ticker.l),
                            quantity: parseFloat(ticker.v),
                            quota: parseFloat(ticker.q)
                        };
                        updateCount++;
                    }
                });
                
                // 更新显示列表
                this.list = this.tradeCurrency[this.tagSelected]['currency'].slice(
                    this.psize * (this.page - 1), 
                    this.page * this.psize
                );
                
                // 更新trades变量
                trades = this.tradeCurrency;
            }
            
            // 2. 更新期权数据
            if (this.allFuturesData && this.allFuturesData.length > 0) {
                let optionUpdateCount = 0;
                
                // 创建一个symbol到ticker的映射表
                const symbolTickerMap = {};
                if (this.tradeCurrency && this.tradeCurrency[0] && this.tradeCurrency[0].currency) {
                    this.tradeCurrency[0].currency.forEach(currency => {
                        if (currency.symbol) {
                            const ticker = util.getCurrentTicker(currency.id, tickerData);
                            if (ticker && ticker.c) {
                                symbolTickerMap[currency.symbol] = {
                                    new_price: parseFloat(ticker.c),
                                    change_rate: parseFloat(ticker.P),
                                    high_price: parseFloat(ticker.h),
                                    low_price: parseFloat(ticker.l),
                                    quantity: parseFloat(ticker.v),
                                    quota: parseFloat(ticker.q)
                                };
                            }
                        }
                    });
                }
                
                // 更新期权数据
                this.allFuturesData.forEach((futures, index) => {
                    if (futures.symbol && symbolTickerMap[futures.symbol]) {
                        const tickerInfo = symbolTickerMap[futures.symbol];
                        this.allFuturesData[index] = {
                            ...futures,
                            new_price: tickerInfo.new_price,
                            change_rate: tickerInfo.change_rate,
                            high_price: tickerInfo.high_price,
                            low_price: tickerInfo.low_price,
                            quantity: tickerInfo.quantity,
                            quota: tickerInfo.quota
                        };
                        optionUpdateCount++;
                    }
                });
                
                // 重新筛选期权数据以更新显示
                if (optionUpdateCount > 0) {
                    this.filterFuturesByCategory();
                    logger.debug(`📈 更新了 ${optionUpdateCount} 个期权的价格`);
                }
            }
            
            if (updateCount > 0) {
                // 强制更新视图
                this.$nextTick(() => {
                    this.$forceUpdate();
                });
                
                logger.debug(`📈 更新了 ${updateCount} 个现货币种的价格`);
            }
        },
        
        /**
         * 获取币种列表(初始数据)
         */
        async getTradesCurrency() {
            try {
                logger.log('📊 获取币种列表...');
                const res = await currencyApi.tradeCurrencyList();
                
                if (res && res.data && Array.isArray(res.data) && res.data.length > 0) {
                    this.tradeCurrency = res.data;
                    trades = res.data;
                    
                    if (res.data[0] && res.data[0].currency) {
                        this.total = res.data[0].currency.length;
                        this.list = res.data[0].currency.slice(this.psize * (this.page - 1), this.page * this.psize);
                        
                        logger.log(`✅ 获取到 ${this.total} 个币种`);
                    }
                } else {
                    logger.warn('⚠️ 币种数据格式不正确');
                }
            } catch (error) {
                logger.error('❌ 获取币种列表失败:', error);
                if (error.message && error.message.includes('401')) {
                    logger.log('🔐 用户未登录，需要登录后才能查看完整行情');
                    throw error;
                }
            }
        },
        

        
        /**
         * Swiper滑动事件
         */
        slideChange(e) {
            this.activeIndex = e.activeIndex;
        },
        
        /**
         * 获取本地化标题
         */
        getLocalizedTitle(title) {
            if (!title) return '';

            // 如果是字符串，直接返回
            if (typeof title === 'string') {
                return title;
            }

            // 如果是对象，尝试解析多语言
            if (typeof title === 'object') {
                try {
                    // 如果是JSON字符串，先解析
                    if (typeof title === 'string' && title.startsWith('{')) {
                        title = JSON.parse(title);
                    }

                    // 获取当前语言
                    const currentLang = this.$i18n?.locale || 'en-US';

                    // 根据当前语言返回对应文本
                    if (currentLang === 'zh_CN') {
                        return title['zh_CN'] || title['zh_Hant'] || title['en-US'] || '加密货币';
                    } else if (currentLang === 'zh_Hant') {
                        return title['zh_Hant'] || title['zh_CN'] || title['en-US'] || '加密货币';
                    } else if (currentLang === 'en-US') {
                        return title['en-US'] || title['zh_CN'] || title['zh_Hant'] || 'Crypto';
                    } else {
                        // 默认返回中文
                        return title['zh_CN'] || title['zh_Hant'] || title['en-US'] || '加密货币';
                    }
                } catch (error) {
                    logger.warn('⚠️ 解析多语言标题失败:', error);
                    return '加密货币';
                }
            }

            return '加密货币';
        }
    }
}
